import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=1f155c5e&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f155c5e')) {
      api.createRecord('1f155c5e', component.options)
    } else {
      api.reload('1f155c5e', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=1f155c5e&", function () {
      api.rerender('1f155c5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Tfvs1fRTZdVR/JS/pricehelp.vue"
export default component.exports